import { CONTACT_SUBMIT } from "./types";

export const createContact = (contact) => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        fetch(`${process.env.REACT_APP_API_URL}/contact.php`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(contact),
        })
            .catch(err => reject(err))
            .then((post) => {
                dispatch({
                    type: CONTACT_SUBMIT,
                    payload: post,
                });

                resolve(post);
            });
    });
};
